import {  EmptyObservable  } from './EmptyObservable';

export const empty = EmptyObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/empty.ts